import React, { FC, ReactNode } from 'react'
import { LoggingInLoadingOverlay } from '../../components/LoggingInLoadingOverlay/LoggingInLoadingOverlay'
import { AppHeader } from '../AppHeader'
import { UserSessionContainer } from '../../components/session/UserSessionContainer/UserSessionContainer'
import { ConditionalRender } from 'components/ConditionalRender/ConditionalRender'
import { Footer } from 'components/page/footer/Footer'
import { locales } from '../../translations/i18n'
import { MobileAppBottomBar } from 'components/page/mobileAppBottomBar/MobileAppBottomBar'
import { PaymentContainer } from 'components/payment/PaymentContainer/PaymentContainer'
import { ContentLayout } from './ContentLayout'
import { NATIVE_APP_HELPER } from 'constants/native_app_helper.constants'

type MainLayoutProps = {
  channel: any
  loggingIn: boolean
  showLoading: boolean
  isRootOrChild: any
  isViewingStream: boolean
  channelDataIsReady: boolean
  children: ReactNode
}

export const MainLayout: FC<MainLayoutProps> = ({
  children,
  channel,
  loggingIn,
  showLoading,
  isRootOrChild,
  isViewingStream,
  channelDataIsReady
}) => {
  const showAccountHeader = location.pathname.includes('/user/profile')
  const isBrowsePage =
    location.pathname === '/browse' || location.pathname === '/'
  const isBroadcastPage = location.pathname === '/broadcast'
  const showBasicHeader = location.pathname === '/landing'
  const addTopSpacer =
    !isBrowsePage && !showBasicHeader && !isBroadcastPage && !showAccountHeader
  const companyName = 'Solidsport AB'
  return (
    <>
      <LoggingInLoadingOverlay loggingIn={loggingIn} />
      <AppHeader
        showAccountHeader={showAccountHeader}
        showBasicHeader={showBasicHeader}
        addTopSpacer={addTopSpacer}
        isRootOrChild={isRootOrChild}
        isViewingStream={isViewingStream}
        isRootClubChannel={channel?.data?.isRootClubChannel}
        isLoading={showLoading}
      />
      <div
        style={
          NATIVE_APP_HELPER.GET_PLATFORM === 'ios'
            ? { paddingTop: '40px', paddingBottom: '70px' }
            : undefined
        }
      >
        <ContentLayout isLoading={showLoading}>{children}</ContentLayout>
      </div>
      <UserSessionContainer />
      <ConditionalRender mobileApp={false}>
        {!isViewingStream && !showAccountHeader && (
          <Footer
            isRootOrChild={isRootOrChild}
            channelDataIsReady={channelDataIsReady}
            companyName={companyName}
            locales={locales}
          />
        )}
      </ConditionalRender>
      <ConditionalRender web={false} mobileApp={!isViewingStream}>
        <MobileAppBottomBar />
      </ConditionalRender>
      <PaymentContainer />
    </>
  )
}
